import { Skeleton } from '@/components/ui/skeleton';

export const LoadingSkeleton = ({ children }: { children?: React.ReactNode }) => (
  <div className="flex flex-col justify-center px-3 py-2">
    {children ? children : (
      <>
        <Skeleton className="h-3 w-[250px] bg-gray-300 my-1"/>
        <Skeleton className="h-3 w-[200px] bg-gray-300 my-1"/>
        <Skeleton className="h-3 w-[250px] bg-gray-300 my-1"/>
      </>
    )}
  </div>
);
